export default __webpack_public_path__ + "static/media/bicos.a0a884f5.png";